module.exports = __webpack_public_path__ + "static/img/car2.db7ae4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/car2.jpg
// module id = LSmy
// module chunks = 0